<template>
  <ModalBase
    :is-active="props.isActive"
    @update:is-active="value => $emit('update:isActive', value)"
  >
    <div class="modal__title">
      Вы уверены?
    </div>
    <p>{{ message }}</p>
    <div class="modal__buttons">
      <ButtonAccentPrimary
        size="large"
        class="bordered same-width"
        @click="$emit('cancel')"
      >
        Отмена
      </ButtonAccentPrimary>
      <ButtonAccentPrimary
        size="large"
        class="same-width"
        @click="$emit('confirm')"
      >
        Подтвердить
      </ButtonAccentPrimary>
    </div>
  </ModalBase>
</template>

<script setup>
import { defineProps } from "vue";
import ModalBase from "@/components/UI/ModalBase.vue";

const props = defineProps({
    isActive: {
        type: Boolean,
        required: true
    },
    message: {
        type: String,
        default: ""
    },
});

defineEmits(["confirm", "cancel", "update:isActive"]);
</script>
<style lang="scss" scoped>
.modal {
    white-space: wrap;
    text-align: center;
    &__title {
        margin-bottom: 30px;
        font-size: 28px;
        color: #1F9AFF;
    }
    &__buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
    }
}
</style>